import { Copies } from "shared/hooks/useCopies";
import ProgramAgendaStatus from "shared/enums/ProgramAgendaStatus";

export function getFilterOptions(
  copies: Copies,
  countsMap: Record<ProgramAgendaStatus, number>
): { label: string; value: ProgramAgendaStatus; customData: { filterlabel: string } }[] {
  return [
    {
      label: copies.get("my.experience.associate.program.filter.unaccepted"),
      value: ProgramAgendaStatus.SCHEDULED,
      customData: {
        filterlabel: `${copies.get("associated.program.pending.shortlist.action")} (${
          countsMap[ProgramAgendaStatus.SCHEDULED]
        })`
      }
    },
    {
      label: copies.get("my.experience.associate.program.filter.accepted"),
      value: ProgramAgendaStatus.CONFIRMED,
      customData: {
        filterlabel: `${copies.get("my.experience.associate.program.filter.accepted")} (${
          countsMap[ProgramAgendaStatus.CONFIRMED]
        })`
      }
    },
    {
      label: copies.get("my.experience.associate.program.filter.rejected"),
      value: ProgramAgendaStatus.REJECTED,
      customData: {
        filterlabel: `${copies.get("my.experience.associate.program.filter.rejected")} (${
          countsMap[ProgramAgendaStatus.REJECTED]
        })`
      }
    }
  ];
}
